<script>
    import { TOKEN_SESSION, USER } from '../stores'
    import { createEventDispatcher } from 'svelte';
    import { onMount } from 'svelte';
    import * as Fx from '../globals/Fx'
    import ReportesFavoritos from './Reportes/ReportesFavoritos.svelte';
        
    const dispatch = createEventDispatcher()
    
    onMount (async () => {
    
    })
        
    </script>
    
    <div class="main-home">
        {#if $USER}
            <div class="user-info">
                <div class="bullet">
                    <ion-icon name="person-outline"></ion-icon>
                </div>
                <span class="nombre">{$USER["usu_nombre"].toLowerCase()}</span>
                <span class="email">{$USER["usu_email"]}</span>
            </div>
        {:else}
             <!-- else content here -->
        {/if}
        <div class="d-flex justify-content-center text-center title-text flex-column" style="">
            <div>Alumbrado Público</div>
            <div>Software para Liquidación</div> 
            <div>de Impuesto y Cartera</div>
            <img style="align-self:center;margin-top:20px" width="200px" src="./images/logo-essmar.png" alt="">
        </div>
        {#if $USER}
             <ReportesFavoritos rep_usu_id={$USER.usu_id} />
        {/if}
    </div>
    
    <style>
        .main-home {
            /* display: flex; */
            flex-direction: column;
            justify-content: center;
            padding-top: 100px;
            overflow-y: auto;
            height: 100vh;
            padding-bottom: 100px;
        }

        .user-info {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .bullet {
            background-color: #3498db;
            border-radius : 50%;
            width: 8em;
            height: 8em;
            justify-content: center;
            align-items: center;
            display: flex;
            margin-bottom: 1em;
            cursor: pointer;
            align-items: center;
            color: #fff;
        }

        ion-icon {
            font-size: 4em;
        }

        .nombre {
            font-size: 2em;
            line-height: 0.7;
            font-family: 'Roboto';
        }

        .email {
            font-size: 1.1em;
            color: #7f8c8d;
        }

        .title-text {
            line-height: 1; 
            font-size: 3.5em;
            color:#34495e55;
            padding: 20px 0;
        }

    </style>